<template>
  <div class="threesixty-player no-swipe-nav">
    <div class="threesixty-player__innerwrap">
      <canvas :class="{ hide: (highlightedFrameUrl && ticker === 0) }" :width="width" :height="height" class="threesixty-player__canvas"></canvas>
      <div class="threesixty-player__bullets" v-if="info" :class=" { show: (ticker == 0 && !dragging && loaded && !highlightedFrameIndex)}">
        <bullet
          :key="index"
          :index="index"
          v-for="(b, index) in bullets"
          :x="b.x"
          :y="b.y"
        >
        </bullet>
      </div>

      <transition name="fade" mode="out-in" appear>
        <img class="threesixty-player__highlight" v-if="highlightedFrameUrl && ticker === 0" :src="highlightedFrameUrl" />
      </transition>
    </div>
    <div class="threesixty-player__preloader" :style="{width: loadedPercent, opacity: !loaded ? 1 : 0}"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import Bullet from './Bullet';

export default {
  name: 'threesixty-player',
  components: { Bullet },
  props: ['width', 'height', 'frames', 'bulletsJson', 'info'],
  data() {
    return {
      collection: [],
      imagesLoaded: 0,
      imagesTotal: this.frames.length,
      currentFrame: 48,
      // currentTime: null,
      endFrame: 0,
      // startFrame: null,
      ctx: null,
      // frame: 0,
      // playing: false,
      // fps: 35,
      bulletsArray: [],
      bullets: [],
      startX: 0,
      endX: 0,
      distance: 0,
      dragging: false,
      touch: false,
      monitorStartTime: 0,
      ticker: 0,
      MONITOR_INTERVAL: 10,
      SPEED_MULTIPLIER: 10,
      loaded: false,
    };
  },
  mounted() {
    this.loadBullets();
    const aspectRatio = this.height / this.width;
    const innerwrap = this.$el.querySelector('.threesixty-player__innerwrap');
    let maxHeight = this.$el.offsetHeight;
    innerwrap.style.maxWidth = (maxHeight / aspectRatio) + 'px'; //eslint-disable-line

    window.addEventListener('resize', () => {
      maxHeight = this.$el.offsetHeight;
      innerwrap.style.maxWidth = (maxHeight / aspectRatio) + 'px'; //eslint-disable-line
    });
  },
  methods: {
    animateToFrame(frame) {
      const currentFrame = this.getNormalizedCurrentFrame();

      const diff = (currentFrame - frame);
      const absDiff = Math.abs(diff);

      if (absDiff <= (this.imagesTotal / 2)) {
        this.endFrame += diff;
      } else if (diff >= 0) {
        this.endFrame -= (this.imagesTotal - 1) - diff;
      } else {
        this.endFrame += (this.imagesTotal - 1) + diff;
      }
      this.animate();
    },
    loadBullets() {
      const bulletsUrl = this.bulletsJson;
      axios.get(bulletsUrl).then((response) => {
        this.bulletsArray = response.data;

        /* eslint-disable no-param-reassign */
        this.bulletsArray.forEach((bullets) => {
          bullets.forEach((bullet) => {
            bullet.x = (bullet.x / 1024) * 100;
            bullet.y = (bullet.y / 768) * 100;
          });
        });
        this.bullets = this.bulletsArray[0];
        this.imagesLoaded = 0;
        this.init();
      }, () => {
        this.init();
      });
    },
    preload() {
      this.imagesLoaded = 0;
      this.collection = [];

      for (let i = 0; i < this.imagesTotal; i += 1) {
        this.collection[i] = new Image();
        this.collection[i].addEventListener('load', this.handleImageLoaded);
        this.collection[i].src = this.frameUrl(i);
      }
    },
    handleImageLoaded() {
      this.imagesLoaded += 1;
      if (this.imagesLoaded === this.imagesTotal * 1) {
        this.loaded = true;
        this.animate(0, 1);
      }
    },
    initListeners() {
      this.ctx = this.$el.querySelector('canvas').getContext('2d');
      this.$el.querySelector('canvas').addEventListener('touchstart', this.handleTouchStart);
      this.$el.querySelector('canvas').addEventListener('touchend', this.handleTouchEnd);

      this.$el.querySelector('canvas').addEventListener('mousedown', this.handleMouseDown);
      this.$el.querySelector('canvas').addEventListener('mouseup', this.handleTouchEnd);

      this.$el.querySelector('canvas').addEventListener('touchmove', this.handleTouchMove);
      this.$el.querySelector('canvas').addEventListener('mousemove', this.handleMouseMove);
    },
    handleTouchStart(event) {
      event.preventDefault();
      event.stopPropagation();

      this.touch = true;
      this.startX = event.changedTouches[0].clientX;
      this.$router.push({ params: { selectedBullet: -1 } });
    },
    handleMouseDown(event) {
      event.preventDefault();
      event.stopPropagation();

      this.touch = true;
      this.startX = event.clientX;
      this.$router.push({ params: { selectedBullet: -1 } });
    },
    handleTouchEnd(event) {
      event.preventDefault();
      event.stopPropagation();

      this.dragging = false;
      this.touch = false;
    },
    handleTouchMove(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.touch) {
        this.dragging = true;
      }

      if (this.dragging) {
        this.endX = event.changedTouches[0].clientX;

        if (this.monitorStartTime < new Date().getTime() - this.MONITOR_INTERVAL) {
          this.distance = this.endX - this.startX;
          this.endFrame = this.currentFrame
            + Math.ceil((this.imagesTotal - 1)
            * this.SPEED_MULTIPLIER * (this.distance / this.width));

          if (this.ticker === 0) {
            this.animate();
          }

          this.monitorStartTime = new Date().getTime();
          this.startX = event.changedTouches[0].clientX;
        }
      }
    },
    handleMouseMove(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.touch) {
        this.dragging = true;
      }

      if (this.dragging) {
        this.endX = event.clientX;

        if (this.monitorStartTime < new Date().getTime() - this.MONITOR_INTERVAL) {
          this.distance = this.endX - this.startX;
          this.endFrame = this.currentFrame
            + Math.ceil((this.imagesTotal - 1)
            * this.SPEED_MULTIPLIER * (this.distance / this.width));

          if (this.ticker === 0) {
            this.animate();
          }

          this.monitorStartTime = new Date().getTime();
          this.startX = event.clientX;
        }
      }
    },
    init() {
      if (!this.imagesLoaded) {
        this.preload();
        this.initListeners();
      }
    },
    animate() {
      this.ticker = requestAnimationFrame(this.animate);
      this.render();
    },
    frameUrl(index) {
      return this.frames[index];
    },
    pad(num) {
      let stringNum = num.toString();
      while (stringNum.length < 2) {
        stringNum = `0${stringNum}`;
      }
      return stringNum;
    },
    rightNow() {
      if (window.performance && window.performance.now) {
        return window.performance.now();
      }

      return Number(new Date());
    },
    render() {
      if (this.currentFrame !== this.endFrame) {
        const easing = this.endFrame < this.currentFrame
          ? Math.floor((this.endFrame - this.currentFrame) * 0.1)
          : Math.ceil((this.endFrame - this.currentFrame) * 0.1);
        this.currentFrame += easing;
        this.ctx.clearRect(0, 0, this.width, this.height);
        this.ctx.drawImage(this.collection[this.getNormalizedCurrentFrame()],
          0,
          0,
          this.width,
          this.height);
      } else {
        cancelAnimationFrame(this.ticker);
        this.bullets = this.bulletsArray[this.getNormalizedCurrentFrame()];
        this.ticker = 0;
      }
    },
    getNormalizedCurrentFrame() {
      let currentFrame = -Math.ceil(this.currentFrame % this.imagesTotal);
      if (currentFrame < 0) {
        currentFrame += (this.imagesTotal - 1);
      }
      return currentFrame;
    },
  },
  computed: {
    ...mapGetters(['highlightedFrameIndex', 'highlightedFrameUrl']),
    loadedPercent() {
      let percent;
      if (!this.loaded) {
        percent = ((this.imagesLoaded / this.imagesTotal) * 100) + '%'; // eslint-disable-line prefer-template
      } else {
        percent = 0;
      }
      return percent;
    },
  },
  watch: {
    frames() {
      this.currentFrame -= 1;
      this.loadBullets();
    },
    highlightedFrameIndex() {
      if (this.highlightedFrameIndex !== false) {
        this.animateToFrame(this.highlightedFrameIndex);
      }
    },
  },
};
</script>

<style lang="scss">
  @import '../scss/helpers.scss';
  .threesixty-player {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    overflow: hidden;

    &__innerwrap {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;

      &::before {
        content: '';
        display: block;
        width: 80%;
        padding-top: 22.65%;
        position: absolute;
        left: 10%;
        right: 10%;
        bottom: 0;
        z-index: -1;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url('../../static/svg/360_arrow.svg');
      }
    }

    &__bullets {
      pointer-events: none;

      &.show {
        pointer-events: auto;
      }
    }

    &__bullets.show &__bullet {
      opacity: 1;
    }

    &__canvas {
      width: 100%;
      transition: opacity .5s cubic-bezier(.75,.01,.25,1);

      &.hide {
        opacity: 0;
      }
    }

    &__highlight {
      position: absolute;
      width: 100%;
      top: 0;
      opacity: 1;
      pointer-events: none;
      transition: opacity .5s cubic-bezier(.75,.01,.25,1);
    }

    &__preloader {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 0;
      transition: width 2s, opacity 1s;
      background: rgba($c_primary, .75);
    }
  }
  
  .fade-enter, .fade-leave-to {
    bottom: -200px;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ThreeSixtyPlayer.vue